export default __webpack_public_path__ + "static/media/FreeFinancialProgram.aa962119.svg";